'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLocation = parseLocation;

var _queryString = require('query-string');

/*
 * 
 * Converts a raw location object from the browser window into an object
 * that is easier to parse and query.
 */
function parseLocation(location) {
  return { path: location.pathname, params: (0, _queryString.parse)(location.search) || {} };
} // Common functions to work with urls